import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonProductTop = () => {
    return (
        <div className="skeleton-product-top-wrapper xmt-20">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div
                            className="product-gallery skeleton-loading br-4 position-relative d-flex align-items-end xp-4">
                            <div className="product-price position-absolute">
                                <div className="price-wrapper skeleton-loading position-relative">
                                    <div className="discount skeleton-loading position-absolute"></div>
                                </div>
                            </div>
                            <div className="thumbnail-wrapper d-flex align-items-center">
                                <div className="thumb-box skeleton-loading"></div>
                                <div className="thumb-box skeleton-loading"></div>
                                <div className="thumb-box skeleton-loading"></div>
                                <div className="thumb-box skeleton-loading"></div>
                                <div className="thumb-box skeleton-loading long-box"></div>
                                <div className="thumb-box d-flex align-items-center justify-content-center"><IconName
                                    name="chevron_left" className="icon"/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="text-sk text--1 skeleton-loading xmt-4"></div>
                        <div className="text-sk text--2 skeleton-loading xmt-8"></div>
                        <div className="product-star d-flex align-items-center xmt-4">
                            <div className="star"><IconName name="star" className="icon"/> <IconName name="star"
                                                                                                     className="icon"/>
                                <IconName name="star" className="icon"/> <IconName name="star" className="icon"/>
                                <IconName name="star" className="icon"/></div>
                            <div className="share-product xmr-12 d-flex align-items-center">
                                <IconName name="share" className="icon"/>
                                <div className="text-sk text--3 skeleton-loading xmr-2"></div>
                            </div>
                        </div>
                        <div className="product-information skeleton-loading xmt-8 br-4"></div>
                        <div className="switch-buttons-wrapper xmt-10 d-flex align-items-center">
                            <div className="switch-button xpx-2 skeleton-loading active">
                                <div className="status"></div>
                            </div>
                            <div className="switch-button xpx-2 skeleton-loading">
                                <div className="status"></div>
                            </div>
                            <div className="switch-button xpx-2 skeleton-loading">
                                <div className="status"></div>
                            </div>
                            <div className="switch-button xpx-2 skeleton-loading">
                                <div className="status"></div>
                            </div>
                        </div>
                        <div className="sellers-box xmt-10">
                            <ul className="list-unstyled br-2">
                                <li className="list"><IconName name="chevron_left" className="icon"/></li>
                                <li className="list"><IconName name="chevron_left" className="icon"/></li>
                            </ul>
                        </div>
                        <div className="buttons-wrapper xmt-10 d-flex align-items-center">
                            <div className="button-sk button--1 skeleton-loading"></div>
                            <div className="button-sk xmr-4 button--2 skeleton-loading"></div>
                            <div className="button-sk xmr-4 button--3 skeleton-loading"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonProductTop;
